<template>
	<div class="couponsConfig">
		<form-combination ref="formName" :form-data="formData"></form-combination>
		<div class="button">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="confirm">确定</el-button>
		</div>
	</div>
</template>

<script>
import filters from '@/mixins/filters.js';
import { validRequired, validRequired_copy } from '@/common/elementValid.js';
import inputMessage from '@/components/SaaS/inputMessage';
import couponsSaasDataList from '@/components/SaaS/couponsSaasDataListCopy';
import setmeal from '@/backend/services/account/setmeal.js';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';

import { currencies } from '@/common/dictionary.js';

export default {
	name: 'couponsConfig',
	data() {
		return {
			formData: {},
			dialogColumn: [],
			update: false,
			isCopy: false,
			updateId: '',
			couponsPackagesList: [],
		};
	},
	components: { formCombination },
	async mounted() {
		try {
			let { id, type } = this.$route.query;
			let { data } = await setmeal.couponsPackagesChoose();
			this.couponsPackagesList = data;
			this.update = type === 'edit' ? true : false;
			this.isCopy = type === 'copy' ? true : false;
			this.updateId = id;
			if (id) {
				let res = await setmeal.couponsDetails({ id });
				this.setFormData(res.data);
			} else {
				this.setFormData();
			}
		} catch (err) {
			throw new Error(err);
		}
	},
	methods: {
		// 确定
		confirm() {
			this.$refs.formName.validate(async valid => {
				if (valid) {
					try {
						let { update, updateId: id, formData, isCopy } = this;
						let data = {};
						let formDataCopy = _.cloneDeep(formData);
						Object.keys(formDataCopy).forEach(key => {
							data[key] = formDataCopy[key].value || '';
						});
						if (update && !isCopy) {
							await setmeal.editCoupons(id, data);
						} else {
							await setmeal.addCoupons(data);
						}
						this.$router.go(-1);
						this.$message.success('操作成功');
					} catch (error) {
						this.$message.warning('操作失败');
					}
				}
			});
		},
		// 取消
		close() {
			this.$router.go(-1);
		},
		// 设置表单现
		setFormData(val = {}) {
			let that = this;
			let { currency } = val;
			let { update, isCopy } = this;

			let couponsPackagesListCopy = this.filterPackagesList(currency || 127001);

			this.formData = {
				name: {
					label: '优惠名称',
					formType: inputMessage,
					message: '采用下斜杠“_”后的文字内容会在客户端进行过滤显示',
					value: isCopy ? '' : val.name,
					rules: [validRequired()],
				},
				currency: {
					label: '币种',
					formType: 'sky-select',
					customOption: true,
					setOptionValue(item) {
						return `${item.symbol}`;
					},
					value: val.currency || 127001,
					options: currencies,
					disabled: update,
					placeholder: '请选择币种',
					rules: [validRequired('请选择币种', 'blur')],
					change(val) {
						that.formData.functionItemList.currency = val;
						that.formData.packageId.options = that.filterPackagesList(val);
					},
				},
				packageId: {
					label: '套餐选择',
					formType: 'sky-select',
					value: isCopy ? '' : val.packageId,
					content:
						'已配置优惠的套餐和停用的套餐不会出现在列表中，若要设置请先停用原有优惠或开启已停用的套餐',
					showToolTip: true,
					options: couponsPackagesListCopy,
					disabled: update,
					props: {
						label: 'packageName',
						value: 'id',
					},
					rules: [validRequired()],
				},
				functionItemList: {
					label: '选择赠送功能',
					formType: couponsSaasDataList,
					currency: val.currency || 127001,
					value: val.functionItemList || [],
					rules: [validRequired_copy()],
				},
				orderType: {
					label: '订单类型',
					formType: 'sky-radio',
					value: val.orderType || '',
					border: true,
					options: [
						{
							label: '新单',
							value: 1,
						},
						{
							label: '续费',
							value: 2,
						},
					],
					rules: [validRequired()],
				},
				remarks: {
					label: '备注',
					formType: 'sky-textarea',
					'show-word-limit': true,
					rows: 4,
					value: val.remarks || '',
				},
			};
		},
		// 根据币种筛选套餐列表
		filterPackagesList(currencyVal) {
			let { couponsPackagesList } = this;

			return _.cloneDeep(couponsPackagesList)
				.filter(item => {
					let { priceList } = item;
					let obj = priceList.find(({ currency }) => currency === currencyVal);
					return obj ? true : false;
				})
				.map(item => {
					let { id, packageName } = item;
					return { id, packageName };
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.couponsConfig {
	.button {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
}
</style>
